import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  static values = { autohide: Boolean }

  connect() {
    this.toast = new Toast(this.element, { autohide: this.autohideValue, delay: 5000 })
    this.toast.show()
  }

  disconnect() {
    // Finish a pending fade before disposal clears Bootstrap's element reference.
    this.element.dispatchEvent(new Event("transitionend"))
    this.toast?.dispose()
  }

  remove() {
    this.element.remove()
  }
}
